import React, { useEffect, useRef, useState } from "react";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import { placeholderSelectColor } from "../../NetworkIntelligence/UsageCoverage/helper";
import {
  BookingFlowStepsArr,
  ServiceFlowStep,
  intitalValue,
} from "./addServiceHelper";
import Select from "react-select";
import { InputOptionSelect } from "../../../../common/InputOptionSelect";
import {
  AddUpdateServiceType,
  getDiagnosticCategoryAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import { useDispatch, useSelector } from "react-redux";

export const AddServicePopup = ({
  isAddService,
  setIsAddService,
  searchFilter,
}) => {
  const ref = useRef();
  const [data, setData] = useState(null);
  const [serviceBtnColorVali, setServiceBtnColorVali] = useState(null);
  const [boxColorCodeVal, setBoxColorVal] = useState(null);
  const [bookingFlowStepsArr, setBookingFlowStepsArr] = useState(null);
  const [serviceFlowTypeArr, setServiceFlowTypeArr] = useState(null);
  const [planBoxColorVal, setPlanBoxColorVal] = useState(null);
  const [boxFooterColor, setBoxFooterColor] = useState(null);
  const [formData, setFormData] = useState(intitalValue);
  const [serviceBullets, setServiceBullets] = useState([
    { bullets: "", serviceName: formData?.serviceName },
  ]);
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer?.getServiceCreationDetail
  );
  const dispatch = useDispatch();
  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleClose = () => {
    ref.current.reset();
    // resetForm()
    setIsAddService({
      isOpen: false,
      rowData: null,
    });
    setFormData(intitalValue);
    setData(null);
  };

  useEffect(() => {
    if (isAddService?.rowData !== null) {
      const temp = {
        serviceName: TestPackageCreationReducer?.serviceName,
        serviceFontName: TestPackageCreationReducer?.serviceFontName,
        serviceBoxColorCode: TestPackageCreationReducer?.serviceBoxColorCode,
        myPlanPageServiceFontSize:
          TestPackageCreationReducer?.myPlanPageServiceFontSize === null
            ? ""
            : TestPackageCreationReducer?.myPlanPageServiceFontSize,
        serviceSubTextSize:
          TestPackageCreationReducer?.serviceSubTextSize === null
            ? ""
            : TestPackageCreationReducer?.serviceSubTextSize,
        serviceSubTextFont: TestPackageCreationReducer?.serviceSubTextFont,
        subServiceText: TestPackageCreationReducer?.subServiceText,
        serviceBtnColor: TestPackageCreationReducer?.serviceBtnColor,
        serviceBtnText: TestPackageCreationReducer?.serviceBtnText,
        // providerId: formData?.providerId,
        homePageServiceFontSize:
          TestPackageCreationReducer?.homePageServiceFontSize === null
            ? ""
            : TestPackageCreationReducer?.homePageServiceFontSize,
        boxFooterColorCode: TestPackageCreationReducer?.boxFooterColorCode,
        boxColorCode_1: TestPackageCreationReducer?.boxColorCode_1,
        aboutImage: TestPackageCreationReducer?.aboutImagePath,
        serviceHeaderImage: TestPackageCreationReducer?.serviceHeaderImagePath,
        serviceIcon: TestPackageCreationReducer?.serviceIconPath,
        servicePoweredBylogo:
          TestPackageCreationReducer?.servicePoweredByLogoPath,
        icon: TestPackageCreationReducer?.iconPath,
        bookingFlowSteps: TestPackageCreationReducer?.bookingFlowSteps,
        iconSize:
          TestPackageCreationReducer?.iconSize === null
            ? ""
            : TestPackageCreationReducer?.iconSize,
        serviceFlowType: TestPackageCreationReducer?.serviceFlowType,
        brandLogoSize:
          TestPackageCreationReducer?.brandLogoSize === null
            ? ""
            : TestPackageCreationReducer?.brandLogoSize,
        serviceBtnText: TestPackageCreationReducer?.serviceBtnText,
        serviceBtnColor: TestPackageCreationReducer?.serviceBtnColor,
        serviceLongDesc:
          TestPackageCreationReducer?.serviceAboutJson?.serviceLongDesc,
        // sKUmessage_1: TestPackageCreationReducer?.skUmessage_1,
        // iconPath_1: TestPackageCreationReducer?.iconPath_1 === null ? "" : TestPackageCreationReducer?.iconPath_1,
        // sKUmessage_2: TestPackageCreationReducer?.skUmessage_2,
        // iconPath_2: TestPackageCreationReducer?.iconPath_2 === null ? "" : TestPackageCreationReducer?.iconPath_2,
        // sKUmessage_3: TestPackageCreationReducer?.skUmessage_3,
        // iconPath_3: TestPackageCreationReducer?.iconPath_3 === null ? "" : TestPackageCreationReducer?.iconPath_3,
        // sKUmessage_4: TestPackageCreationReducer?.skUmessage_4,
        // iconPath_4: TestPackageCreationReducer?.iconPath_4 === null ? "" : TestPackageCreationReducer?.iconPath_4,
        // sKUmessage_5: TestPackageCreationReducer?.skUmessage_5,
        // iconPath_5: TestPackageCreationReducer?.iconPath_5 === null ? "" : TestPackageCreationReducer?.iconPath_5,
      };
      setFormData(temp);
      setServiceBullets(
        TestPackageCreationReducer?.serviceAboutJson?.serviceBullets ===
          undefined
          ? [{ bullets: "", serviceName: formData?.serviceName }]
          : TestPackageCreationReducer?.serviceAboutJson?.serviceBullets
      );
    }
  }, [TestPackageCreationReducer]);
  const serviceBulletHandler = (id, name, value) => {
    serviceBullets[0].serviceName = formData?.serviceName;
    let data = serviceBullets?.map((ele, index) => {
      if (index === id) {
        ele[name] = value;
      }
      return ele;
    });
    setServiceBullets(data);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      if (boxColorCodeVal === false) {
        return;
      } else if (planBoxColorVal === false) {
        return;
      } else if (boxFooterColor === false) {
        return;
      } else if (formData?.bookingFlowSteps?.length === 0) {
        getSnackbarSuccess(
          "warning",
          "Please select Booking Flow Step",
          dispatch
        );
        return;
      } else if (formData?.serviceFlowType?.length === 0) {
        getSnackbarSuccess(
          "warning",
          "Please select Service Flow Type",
          dispatch
        );
        return;
      }
      let serviceAboutJson = {
        serviceName: formData?.serviceName,
        serviceLongDesc: formData?.serviceLongDesc,
        serviceBullets: serviceBullets.filter((item) => {
          if (item?.bullets !== "") {
            return item;
          }
        }),
      };

      const form = new FormData();
      
      form.append("ServiceAboutJson", JSON.stringify(serviceAboutJson));
      form.append("ServiceName", formData?.serviceName);
      form.append("ServiceName", formData?.serviceName);
      form.append("ServiceFontName", formData?.serviceFontName);
      form.append("ServiceBoxColorCode", formData?.serviceBoxColorCode);
      form.append(
        "MyplanPageServiceFontSize",
        formData?.myPlanPageServiceFontSize
      );
      form.append("ServiceSubTextSize", formData?.serviceSubTextSize);
      form.append("ServiceSubTextFont", formData?.serviceSubTextFont);
      form.append("SubServiceText", formData?.subServiceText);
      // form.append("SubServiceText", formData?.subServiceText);
      form.append("HomePageServiceFontSize", formData?.homePageServiceFontSize);
      form.append("AboutImage", formData?.aboutImage);
      form.append("Icon", formData?.icon);
      form.append("ServiceHeaderImage", formData?.serviceHeaderImage);
      form.append("ServiceIcon", formData?.serviceIcon);
      form.append("ServicePoweredBylogo", formData?.servicePoweredBylogo);
      form.append("bookingFlowSteps", formData?.bookingFlowSteps);
      form.append("serviceFlowType", formData?.serviceFlowType);
      form.append("IconSize", formData?.iconSize);
      form.append("BrandLogoSize", formData?.brandLogoSize);
      form.append("BoxFooterColorCode", formData?.boxFooterColorCode);
      form.append("BoxColorCode_1", formData?.boxColorCode_1);
      form.append("serviceBtnColor", formData?.serviceBtnColor);
      form.append("serviceBtnText", formData?.serviceBtnText);
      if (isAddService?.rowData !== null) {
        form.append("ServiceTypeId", TestPackageCreationReducer?.serviceTypeId);
      }
      const resp = dispatch(AddUpdateServiceType(form));
      resp.then((res) => {
        isLoadingAction(true, dispatch);
        if (res?.data?.status === true) {
          getSnackbarSuccess("success", res?.data?.message, dispatch);
          isLoadingAction(false, dispatch);
          setData(null);
          setIsAddService({
            isOpen: false,
            rowData: null,
          });
          dispatch(getDiagnosticCategoryAction({ ...searchFilter, page: 1 }));
        } else {
          getSnackbarSuccess("error", res?.data?.message, dispatch);
          isLoadingAction(false, dispatch);
        }
      });
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">
          {isAddService?.rowData === null ? "Add Service" : "Update Service"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body addusermodalbox">
          <div className="row">
            <h3 className="pt-2 pb-2">Home Page</h3>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">
                Service Name
                <MandatoryStar />
              </label>
              <input
                name="serviceName"
                type="text"
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                disabled={isAddService?.rowData !== null}
                value={isAddService?.rowData === null ? formData?.serviceName : TestPackageCreationReducer?.facilityDisplayName}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                  // Allow only one space between the first name and the last name
                  if (e.key === " " && e.target.value.split("").length < 1) {
                    e.preventDefault();
                    return;
                  }
                  if (!re.test(e.target.value + e.key)) {
                    e.preventDefault();
                  }
                }}
                required
                onChange={(e) => handleChange("serviceName", e.target.value)}
              />
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">
                Service Icon
                <MandatoryStar />
              </label>
              {formData?.serviceIcon === "" && (
                <input
                  name="serviceIcon"
                  type="file"
                  accept="image/svg+xml"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file.type !== "image/svg+xml") {
                      getSnackbarSuccess(
                        "error",
                        "Only SVG is allowed",
                        dispatch
                      );
                      e.target.value = null;
                      return;
                    }
                    // const reader = new FileReader();
                    // reader.onload = (event) => {
                    //   const img = new Image();
                    //   img.onload = () => {
                    //     const maxWidth = 26; // Maximum width in pixels
                    //     const maxHeight = 26; // Maximum height in pixels
                    //     if (img.width > maxWidth || img.height > maxHeight) {
                    //       // Display error message directly in UI
                    //       getSnackbarSuccess(
                    //         "error",
                    //         `Image dimensions exceed the maximum allowed dimensions of ${maxWidth}x${maxHeight} pixels`,
                    //         dispatch
                    //       );
                    //       // Reset file input value
                    //       e.target.value = null;
                    //     } else {
                    //       handleChange("serviceIcon", file);
                    //       // handleChange("serviceIcon", file);
                    //     }
                    //   };
                    //   img.src = event.target.result;
                    // };
                    // reader.readAsDataURL(file);
                    else {
                      handleChange("serviceIcon", e.currentTarget.files[0]);
                    }
                  }}
                  required
                  className="form-control form-select-admin inputbgavanish serviceicon"
                />
              )}
              {formData?.serviceIcon !== "" && (
                <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                  <a
                    href={formData?.serviceIcon}
                    target="_blank"
                    className="serviceImagename"
                    style={{ color: "black" }}
                  >
                    {formData?.serviceIcon?.name
                      ? formData?.serviceIcon?.name
                      : TestPackageCreationReducer?.serviceIconFileName}
                  </a>
                  <span
                    onClick={() =>
                      setFormData({ ...formData, serviceIcon: "" })
                    }
                  >
                    <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                  </span>
                </label>
              )}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Font Name</label>
              <input
                name="serviceFontName"
                type="text"
                placeholder="Arial"
                className="form-control form-select-admin inputbgavanish"
                value={formData?.serviceFontName}
                onChange={(e) =>
                  handleChange("serviceFontName", e.target.value)
                }
                onKeyPress={(e) => {
                  const re = /[a-zA-Z ]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Font Size</label>
              <input
                name="homePageServiceFontSize"
                type="number"
                min={1}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.homePageServiceFontSize}
                onChange={(e) =>
                  handleChange("homePageServiceFontSize", e.target.value)
                }
                onKeyPress={(e) => {
                  const re = /[0-9]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              <div className="errorInputMessage">
                {/* {errors?.myPlanPageServiceFontSize} */}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Box Color Code</label>
              <div className="d-flex gap-2">
                <div className="col-lg-2 col-md-2">
                  <input
                    name="serviceBoxColorCode"
                    type="color"
                    placeholder="#E7E7F2"
                    style={{ border: "none" }}
                    className="serviceBtnColor"
                    value={formData?.serviceBoxColorCode}
                    onChange={(e) =>
                      handleChange("serviceBoxColorCode", e.target.value)
                    }
                  />
                </div>
                <div>
                  <input
                    name="serviceBoxColorCode"
                    type="text"
                    placeholder="#E7E7F2"
                    className="form-control form-select-admin inputbgavanish"
                    value={formData?.serviceBoxColorCode}
                    onKeyPress={(e) => {
                      if (e.target.value.length > 6) {
                        return e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      handleChange("serviceBoxColorCode", e.target.value);
                      const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{6})$/;
                      if (hexRegex.test(e.target.value) === false) {
                        setBoxColorVal(false);

                        if (e.target.value === "") {
                          setBoxColorVal(null);
                        }
                      } else {
                        setBoxColorVal(true);
                      }
                    }}
                  />
                </div>
              </div>
              {boxColorCodeVal === false && (
                <div className="errorInputMessage">
                  Please enter a valid hex color code
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <h3 className="pt-2 pb-2">My Plan Page</h3>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">
                Icon <MandatoryStar />
              </label>
              {formData?.icon === "" && (
                <input
                  // name="icon"
                  type="file"
                  // value={formData?.icon?.name}
                  required
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file.type !== "image/png") {
                      getSnackbarSuccess(
                        "error",
                        "Only PNG is allowed",
                        dispatch
                      );
                      e.target.value = null;
                      return;
                    } else {
                      handleChange("icon", file);
                    }
                    // const reader = new FileReader();
                    // reader.onload = (event) => {
                    //   const img = new Image();
                    //   img.onload = () => {
                    //     const maxWidth = 20; // Maximum width in pixels
                    //     const maxHeight = 20; // Maximum height in pixels
                    //     if (img.width > maxWidth || img.height > maxHeight) {
                    //       // Display error message directly in UI
                    //       getSnackbarSuccess(
                    //         "error",
                    //         `Image dimensions exceed the maximum allowed dimensions of ${maxWidth}x${maxHeight} pixels`,
                    //         dispatch
                    //       );
                    //       // Reset file input value
                    //       e.target.value = null;
                    //     } else {
                    //       handleChange("icon", file);
                    //     }
                    //   };
                    //   img.src = event.target.result;
                    // };
                    // reader.readAsDataURL(file);
                  }}
                  className="form-control form-select-admin inputbgavanish serviceicon"
                />
              )}
              {formData?.icon !== "" && (
                <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                  <a
                    href={formData?.icon}
                    target="_blank"
                    className="serviceImagename"
                    style={{ color: "black" }}
                  >
                    {formData?.icon?.name
                      ? formData?.icon?.name
                      : TestPackageCreationReducer?.iconFileName}
                  </a>
                  <span onClick={() => setFormData({ ...formData, icon: "" })}>
                    <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                  </span>
                </label>
              )}
              {/* <div className="errorInputMessage">{errors?.icon}</div> */}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Icon Size</label>
              <input
                name="iconSize"
                type="number"
                min={1}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.iconSize}
                onKeyPress={(e) => {
                  const re = /[0-9]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => handleChange("iconSize", e.target.value)}
              />
              {/* <div className="errorInputMessage">{errors?.iconSize}</div> */}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Font Size</label>
              <input
                name="myPlanPageServiceFontSize"
                type="number"
                min={1}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.myPlanPageServiceFontSize}
                onKeyPress={(e) => {
                  const re = /[0-9]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) =>
                  handleChange("myPlanPageServiceFontSize", e.target.value)
                }
              />
              <div className="errorInputMessage">
                {/* {errors?.homePageServiceFontSize} */}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Sub Service Text</label>
              <MandatoryStar />
              <input
                name="subServiceText"
                type="text"
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.subServiceText}
                onKeyPress={(e) => {
                  // const re = /^[a-zA-Z\s]*$/
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                  // Allow only one space between the first name and the last name
                  if (e.key === " " && e.target.value.split("").length < 1) {
                    e.preventDefault();
                    return;
                  }
                  // if (!re.test(e.target.value + e.key)) {
                  //   e.preventDefault();
                  // }
                }}
                onChange={(e) => handleChange("subServiceText", e.target.value)}
                required
              />
              <div className="errorInputMessage">
                {/* {errors?.subServiceText} */}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Sub Text Size</label>
              <input
                name="serviceSubTextSize"
                type="number"
                min={1}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.serviceSubTextSize}
                onKeyPress={(e) => {
                  const re = /[0-9]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) =>
                  handleChange("serviceSubTextSize", e.target.value)
                }
              />
              <div className="errorInputMessage">
                {/* {errors?.serviceSubTextSize} */}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Sub Text Font</label>
              <input
                name="serviceSubTextFont"
                type="text"
                placeholder="Arial"
                className="form-control form-select-admin inputbgavanish"
                value={formData?.serviceSubTextFont}
                onKeyPress={(e) => {
                  const re = /[a-zA-Z ]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) =>
                  handleChange("serviceSubTextFont", e.target.value)
                }
              />
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Box Color Code </label>
              <div className="d-flex gap-2">
                <div className="col-lg-2 col-md-2">
                  <input
                    name="boxColorCode_1"
                    type="color"
                    style={{ border: "none" }}
                    placeholder="#E7E7F2"
                    className="serviceBtnColor"
                    value={formData?.boxColorCode_1}
                    onChange={(e) =>
                      handleChange("boxColorCode_1", e.target.value)
                    }
                  />
                </div>
                <div>
                  <input
                    name="boxColorCode_1"
                    type="text"
                    placeholder="#E7E7F2"
                    className="form-control form-select-admin inputbgavanish"
                    value={formData?.boxColorCode_1}
                    onKeyPress={(e) => {
                      if (e.target.value.length > 6) {
                        return e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      handleChange("boxColorCode_1", e.target.value);
                      const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{6})$/;
                      if (hexRegex.test(e.target.value) === false) {
                        setPlanBoxColorVal(false);
                        if (e.target.value === "") {
                          setPlanBoxColorVal(null);
                        }
                      } else {
                        setPlanBoxColorVal(true);
                      }
                    }}
                  />
                </div>
              </div>
              {planBoxColorVal === false && (
                <div className="errorInputMessage">
                  Please enter a valid hex color code
                </div>
              )}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Box Footer Color Code</label>
              <div className="d-flex gap-2">
                <div className="col-lg-2 col-md-2">
                  <input
                    name="boxFooterColorCode"
                    type="color"
                    placeholder="#E7E7F2"
                    style={{ border: "none" }}
                    className="serviceBtnColor"
                    value={formData?.boxFooterColorCode}
                    onChange={(e) =>
                      handleChange("boxFooterColorCode", e.target.value)
                    }
                  />
                </div>
                <div>
                  <input
                    name="boxFooterColorCode"
                    type="text"
                    placeholder="#E7E7F2"
                    className="form-control form-select-admin inputbgavanish"
                    value={formData?.boxFooterColorCode}
                    onKeyPress={(e) => {
                      if (e.target.value.length > 6) {
                        return e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      handleChange("boxFooterColorCode", e.target.value);
                      const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{6})$/;
                      if (hexRegex.test(e.target.value) === false) {
                        setBoxFooterColor(false);
                        if (e.target.value === "") {
                          setBoxFooterColor(null);
                        }
                      } else {
                        setBoxFooterColor(true);
                      }
                    }}
                  />
                </div>
              </div>
              {boxFooterColor === false && (
                <div className="errorInputMessage">
                  Please enter a valid hex color code
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <h3 className="pt-2 pb-2">About Page</h3>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">
                About Image <MandatoryStar />
              </label>
              {formData?.aboutImage === "" && (
                <input
                  name="aboutImage"
                  type="file"
                  required
                  value={formData?.aboutImage?.name}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file.type !== "image/png") {
                      getSnackbarSuccess(
                        "error",
                        "Only PNG is allowed",
                        dispatch
                      );
                      e.target.value = null;
                      return;
                    }
                    // const reader = new FileReader();
                    // reader.onload = (event) => {
                    //   const img = new Image();
                    //   img.onload = () => {
                    //     const maxWidth = 460; // Maximum width in pixels
                    //     const maxHeight = 460; // Maximum height in pixels
                    //     if (img.width > maxWidth || img.height > maxHeight) {
                    //       // Display error message directly in UI
                    //       getSnackbarSuccess(
                    //         "error",
                    //         `Image dimensions exceed the maximum allowed dimensions of ${maxWidth}x${maxHeight} pixels`,
                    //         dispatch
                    //       );
                    //       // Reset file input value
                    //       e.target.value = null;
                    //     } else {
                    //       handleChange("aboutImage", file);
                    //       // handleChange("serviceIcon", file);
                    //     }
                    //   };
                    //   img.src = event.target.result;
                    // };
                    // reader.readAsDataURL(file);
                    else {
                      handleChange("aboutImage", file);
                    }
                  }}
                  className="form-control form-select-admin inputbgavanish serviceicon"
                />
              )}
              {formData?.aboutImage !== "" && (
                <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                  <a
                    href={formData?.aboutImage}
                    target="_blank"
                    style={{ color: "black" }}
                    className="serviceImagename"
                  >
                    {formData?.aboutImage?.name
                      ? formData?.aboutImage?.name
                      : TestPackageCreationReducer?.aboutImageFileName}
                  </a>
                  <span
                    onClick={() => setFormData({ ...formData, aboutImage: "" })}
                  >
                    <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                  </span>
                </label>
              )}
              <div className="errorInputMessage">
                {/* {errors?.aboutImage} */}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Brand Logo Size</label>
              <input
                name="brandLogoSize"
                type="number"
                min={1}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.brandLogoSize}
                onKeyPress={(e) => {
                  const re = /[0-9]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => handleChange("brandLogoSize", e.target.value)}
              />
              <div className="errorInputMessage">
                {/* {errors?.brandLogoSize} */}
              </div>
            </div>
            {/* <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Flow Type</label><MandatoryStar />
              <input
                name="serviceFlowType"
                type="text"
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.serviceFlowType}
                onKeyPress={(e) => {
                  const re = /[0-9]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => handleChange("serviceFlowType", e.target.value)}
                required
              />
            </div> */}
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Button Text</label>
              <MandatoryStar />
              <input
                name="serviceBtnText"
                type="text"
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                value={formData?.serviceBtnText}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                  // Allow only one space between the first name and the last name
                  if (e.key === " " && e.target.value.split("").length < 1) {
                    e.preventDefault();
                    return;
                  }
                  if (!re.test(e.target.value + e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => handleChange("serviceBtnText", e.target.value)}
                required
              />
            </div>
            <div className="col-lg-4 col-md-4 ">
              <label className="col-form-label">Service Button Color</label>
              <div className="d-flex gap-2">
                <div className="col-lg-2 col-md-2">
                  <input
                    name="serviceBtnColor"
                    type="color"
                    placeholder="#E7E7F2"
                    style={{ border: "none" }}
                    className=" serviceBtnColor"
                    value={formData?.serviceBtnColor}
                    onChange={(e) =>
                      handleChange("serviceBtnColor", e.target.value)
                    }
                  />
                </div>
                <div>
                  <input
                    name="serviceBtnColor"
                    type="text"
                    placeholder="#E7E7F2"
                    className="form-control form-select-admin inputbgavanish"
                    value={formData?.serviceBtnColor}
                    onKeyPress={(e) => {
                      if (e.target.value.length > 6) {
                        return e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      handleChange("serviceBtnColor", e.target.value);
                      const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{6})$/;
                      if (hexRegex.test(e.target.value) === false) {
                        setServiceBtnColorVali(false);
                        if (e.target.value === "") {
                          setServiceBtnColorVali(null);
                        }
                      } else {
                        setServiceBtnColorVali(true);
                      }
                    }}
                  />
                </div>
              </div>
              {serviceBtnColorVali === false && (
                <div className="errorInputMessage">
                  Please enter a valid hex color code
                </div>
              )}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Header Image</label>
              <MandatoryStar />
              {formData?.serviceHeaderImage === "" && (
                <input
                  name="serviceHeaderImage"
                  type="file"
                  value={formData?.serviceHeaderImage?.name}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file.type !== "image/svg+xml") {
                      getSnackbarSuccess(
                        "error",
                        "Only SVG is allowed.",
                        dispatch
                      );
                      e.target.value = null;
                      return;
                    }
                    // const reader = new FileReader();
                    // reader.onload = (event) => {
                    //   const img = new Image();
                    //   img.onload = () => {
                    //     const maxWidth = 144; // Maximum width in pixels
                    //     const maxHeight = 144; // Maximum height in pixels
                    //     if (img.width > maxWidth || img.height > maxHeight) {
                    //       // Display error message directly in UI
                    //       getSnackbarSuccess(
                    //         "error",
                    //         `Image dimensions exceed the maximum allowed dimensions of ${maxWidth}x${maxHeight} pixels`,
                    //         dispatch
                    //       );
                    //       // Reset file input value
                    //       e.target.value = null;
                    //     } else {
                    //       handleChange("serviceHeaderImage", file);
                    //       // handleChange("serviceIcon", file);
                    //     }
                    //   };
                    //   img.src = event.target.result;
                    // };
                    // reader.readAsDataURL(file);
                    else {
                      handleChange("serviceHeaderImage", file);
                    }
                  }}
                  required
                  className="form-control form-select-admin inputbgavanish serviceicon"
                />
              )}
              {formData?.serviceHeaderImage !== "" && (
                <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                  <a
                    href={formData?.serviceHeaderImage}
                    target="_blank"
                    style={{ color: "black" }}
                    className="serviceImagename"
                  >
                    {formData?.serviceHeaderImage?.name
                      ? formData?.serviceHeaderImage?.name
                      : TestPackageCreationReducer?.serviceHeaderImageFileName}
                  </a>
                  <span
                    onClick={() =>
                      setFormData({ ...formData, serviceHeaderImage: "" })
                    }
                  >
                    <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                  </span>
                </label>
              )}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="col-form-label">Service Powered By Logo</label>{" "}
              <MandatoryStar />
              {formData?.servicePoweredBylogo === "" && (
                <input
                  name="servicePoweredBylogo"
                  type="file"
                  value={formData?.servicePoweredBylogo?.name}
                  // className="serviceicon "
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file.type !== "image/png") {
                      getSnackbarSuccess(
                        "error",
                        "Only PNG is allowed",
                        dispatch
                      );
                      e.target.value = null;
                      return;
                    } else {
                      handleChange("servicePoweredBylogo", file);
                    }
                    // const reader = new FileReader();
                    // reader.onload = (event) => {
                    //   const img = new Image();
                    //   img.onload = () => {
                    //     const maxWidth = 110; // Maximum width in pixels
                    //     const maxHeight = 110; // Maximum height in pixels
                    //     if (img.width > maxWidth || img.height > maxHeight) {
                    //       // Display error message directly in UI
                    //       getSnackbarSuccess(
                    //         "error",
                    //         `Image dimensions exceed the maximum allowed dimensions of ${maxWidth}x${maxHeight} pixels`,
                    //         dispatch
                    //       );
                    //       // Reset file input value
                    //       e.target.value = null;
                    //     }
                    //     else {
                    //       handleChange("servicePoweredBylogo", file);
                    //     }
                    //   };
                    //   img.src = event.target.result;
                    // };
                    // reader.readAsDataURL(file);
                  }}
                  required
                  className="form-control form-select-admin inputbgavanish serviceicon"
                />
              )}
              {formData?.servicePoweredBylogo !== "" && (
                <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                  <a
                    href={formData?.servicePoweredBylogo}
                    target="_blank"
                    className="serviceImagename"
                    style={{ color: "black" }}
                  >
                    {formData?.servicePoweredBylogo?.name
                      ? formData?.servicePoweredBylogo?.name
                      : TestPackageCreationReducer?.servicePoweredByLogoFileName}
                  </a>
                  <span>
                    <img
                      src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                      onClick={() =>
                        setFormData({ ...formData, servicePoweredBylogo: "" })
                      }
                    />
                  </span>
                </label>
              )}
            </div>
          </div>
          <div className=" pt-4 pb-2 row">
            <div className="col-6 col-md-6 col-sm-12">
              <label>Booking Flow Step</label> <MandatoryStar />
              <Select
                placeholder="Booking Flow Step"
                className="basic-multi-select bookingFlowStep-filter"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                inputValue={bookingFlowStepsArr?.input}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") {
                    setBookingFlowStepsArr({
                      ...bookingFlowStepsArr,
                      input: value,
                    });
                  }
                  //   if (action.action === "menu-close") {
                  //     setBookingFlowStepsArr({
                  //       ...bookingFlowStepsArr,
                  //       input: "",
                  //     });
                  //   }
                }}
                onChange={(event) => {
                  handleChange(
                    "bookingFlowSteps",
                    event.map((e) => e.value).toString()
                  );
                  setBookingFlowStepsArr({
                    ...bookingFlowStepsArr,
                    options: event,
                  });
                }}
                value={
                  formData?.bookingFlowSteps === ""
                    ? ""
                    : formData?.bookingFlowSteps?.split(",")?.map((e) => ({
                        value: e,
                        label: e,
                      }))
                }
                options={BookingFlowStepsArr}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>
            <div className="col-6 col-md-6 col-sm-12">
              <label>Service Flow Type</label> <MandatoryStar />
              <Select
                placeholder="Service Flow Type"
                className="basic-multi-select bookingFlowStep-filter"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                inputValue={serviceFlowTypeArr?.input}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") {
                    setServiceFlowTypeArr({
                      ...serviceFlowTypeArr,
                      input: value,
                    });
                  }
                  //   if (action.action === "menu-close") {
                  //     setBookingFlowStepsArr({
                  //       ...bookingFlowStepsArr,
                  //       input: "",
                  //     });
                  //   }
                }}
                onChange={(event) => {
                  handleChange(
                    "serviceFlowType",
                    event.map((e) => e.value).toString()
                  );
                  setServiceFlowTypeArr({
                    ...serviceFlowTypeArr,
                    options: event,
                  });
                }}
                value={
                  formData?.serviceFlowType === ""
                    ? ""
                    : formData?.serviceFlowType?.split(",")?.map((e) => ({
                        value: e,
                        label: e,
                      }))
                }
                options={ServiceFlowStep}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>

            <div className="col-6 col-md-6 col-sm-12">
            <div className="col-12 col-md-12 col-sm-12">
                <label className="col-form-label">Service Description</label>
                {/* <MandatoryStar /> */}
                <textarea
                  name="serviceLongDesc"
                  type="text"
                  placeholder="Service Description"
                  value={formData?.serviceLongDesc}
                  onChange={(e) => {
                    handleChange("serviceLongDesc", e.target.value);
                  }}
                  // required
                  className="form-control form-select-admin inputbgavanish serviceicon"
                />
              </div>
              <div className="col-12 d-flex justify-content-between mt-3">
                <div>
                  <label className="col-form-label">Service Bullets</label>
                </div>
                <div>
                  <button
                    className="btn addMoreBulletBtn"
                    type="button"
                    onClick={() =>
                      setServiceBullets([
                        ...serviceBullets,
                        { bullets: "", serviceName: formData.serviceName },
                      ])
                    }
                  >
                    <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
                  </button>
                </div>
              </div>
              
              <div className="col-12 mt-2 ms-3">
                <ul>
                  {serviceBullets?.map((e, index) => {
                    return (
                      <li style={{ listStyleType: "square" }}>
                        <div className="d-flex gap-2 mb-2">
                          <div className="col-10">
                            <input
                              name="serviceLongDesc"
                              type="text"
                              placeholder="Service Description"
                              value={e?.bullets}
                              onChange={(e) => {
                                serviceBulletHandler(
                                  index,
                                  "bullets",
                                  e.target.value
                                );
                              }}
                              // required
                              className="form-control form-select-admin inputbgavanish serviceicon "
                            />
                          </div>
                          <div style={{ margin: "auto" }}>
                            <span>
                              <img
                                src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                                onClick={() => {
                                  let data = serviceBullets?.filter(
                                    (item, i) => i !== index
                                  );
                                  setServiceBullets(data);
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            {/* <div className="col-6">
              <div className="col-12 d-flex justify-content-between mt-3">
                <div>
                  <label className="col-form-label">SKU Message</label>
                </div>
              </div>
              <div className="col-12 mt-2 ms-3">
                <ul>
                  <li style={{ listStyleType: "square" }}>
                    <div className="d-flex gap-2 mb-2">
                      <div className="col-10">
                       
                        <input
                          name="sKUmessage_1"
                          type="text"
                          placeholder="SKU Message"
                          value={formData?.sKUmessage_1}
                          onChange={(e) => {
                            handleChange("sKUmessage_1", e.target.value);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                        />
                         {formData?.iconPath_1 === "" && <input
                          name="iconPath_1"
                          type="file"
                          placeholder="SKU Message"
                          onChange={(e) => {
                            handleChange("iconPath_1", e.target.files[0]);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon "
                        />}
                        {formData?.iconPath_1 !== "" && (
                        <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                          <a
                            href={formData?.iconPath_1}
                            target="_blank"
                            className="serviceImagename"
                            style={{ color: "black" }}
                          >
                            Image1
                          </a>
                          <span
                            onClick={() =>
                              setFormData({...formData,iconPath_1:""})
                            }
                          >
                            <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                          </span>
                        </label>
                      )}
                      </div>
                  
                    </div>
                  </li>
                  <li style={{ listStyleType: "square" }}>
                    <div className="d-flex gap-2 mb-2">
                      <div className="col-10">
                        <input
                          name="sKUmessage_2"
                          type="text"
                          placeholder="SKU Message"
                          value={formData?.sKUmessage_2}
                          disabled={formData?.sKUmessage_1 ? false : true}
                          onChange={(e) => {
                            console.log(formData?.sKUmessage_2);
                            handleChange("sKUmessage_2", e.target.value);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                        />
                        {formData?.iconPath_2 === "" &&  <input
                          name="iconPath_2"
                          type="file"
                          placeholder="SKU Message"
                          disabled={formData?.sKUmessage_1 ? false : true}
                          onChange={(e) => {
                            handleChange("iconPath_2", e.target.files[0]);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon "
                        />}
                          {formData?.iconPath_2 !== "" && (
                        <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                          <a
                            href={formData?.iconPath_2}
                            target="_blank"
                            className="serviceImagename"
                            style={{ color: "black" }}
                          >
                            Image2
                          </a>
                          <span
                            onClick={() =>
                              setFormData({...formData,iconPath_2:""})
                            }
                          >
                            <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                          </span>
                        </label>
                      )}
                      </div>
                    </div>
                  </li>
                  <li style={{ listStyleType: "square" }}>
                    <div className="d-flex gap-2 mb-2">
                      <div className="col-10">
                        <input
                          name="sKUmessage_3"
                          type="text"
                          placeholder="SKU Message"
                          value={formData?.sKUmessage_3}
                          disabled={formData?.sKUmessage_2 ? false : true}
                          onChange={(e) => {
                            handleChange("sKUmessage_3", e.target.value);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                        />
                        {formData?.iconPath_3 === "" && <input
                          name="iconPath_3"
                          type="file"
                          placeholder="SKU Message"
                          disabled={formData?.sKUmessage_2 ? false : true}
                          onChange={(e) => {
                            handleChange("iconPath_3", e.target.files[0]);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon "
                        />}

                        
                            {formData?.iconPath_3 !== "" && (
                        <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                          <a
                            href={formData?.iconPath_3}
                            target="_blank"
                            className="serviceImagename"
                            style={{ color: "black" }}
                          >
                            Image3
                          </a>
                          <span
                            onClick={() =>
                              setFormData({...formData,iconPath_3:""})
                            }
                          >
                            <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                          </span>
                        </label>
                      )}
                      </div>
                     
                    </div>
                  </li>
                  <li style={{ listStyleType: "square" }}>
                    <div className="d-flex gap-2 mb-2">
                      <div className="col-10">
                        <input
                          name="sKUmessage_4"
                          type="text"
                          placeholder="SKU Message"
                          value={formData?.sKUmessage_4}
                          disabled={formData?.sKUmessage_3 ? false : true}
                          onChange={(e) => {
                            handleChange("sKUmessage_4", e.target.value);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                        />
                        {formData?.iconPath_4 === "" && <input
                          name="iconPath_4"
                          type="file"
                          placeholder="SKU Message"
                          disabled={formData?.sKUmessage_3 ? false : true}
                          onChange={(e) => {
                            handleChange("iconPath_4", e.target.files[0]);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon "
                        />}
                        
                               {formData?.iconPath_4 !== "" && (
                        <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                          <a
                            href={formData?.iconPath_4}
                            target="_blank"
                            className="serviceImagename"
                            style={{ color: "black" }}
                          >
                            Image4
                          </a>
                          <span
                            onClick={() =>
                              setFormData({...formData,iconPath_4:""})
                            }
                          >
                            <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                          </span>
                        </label>
                      )}
                      </div>
                     
                    </div>
                  </li>
                  <li style={{ listStyleType: "square" }}>
                    <div className="d-flex gap-2 mb-2">
                      <div className="col-10">
                        <input
                          name="sKUmessage_5"
                          type="text"
                          placeholder="SKU Message"
                          value={formData?.sKUmessage_5}
                          disabled={formData?.sKUmessage_4 ? false : true}
                          onChange={(e) => {
                            handleChange("sKUmessage_5", e.target.value);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                        />
                        {formData?.iconPath_5 === "" && <input
                          name="iconImage"
                          type="file"
                          placeholder="SKU Message"
                          disabled={formData?.sKUmessage_4 ? false : true}
                          onChange={(e) => {
                            handleChange("iconPath_5", e.target.files[0]);
                          }}
                          className="form-control form-select-admin inputbgavanish serviceicon "
                        />}
                        
                                 {formData?.iconPath_5 !== "" && (
                        <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                          <a
                            href={formData?.iconPath_5}
                            target="_blank"
                            className="serviceImagename"
                            style={{ color: "black" }}
                          >
                            Image5
                          </a>
                          <span
                            onClick={() =>
                              setFormData({...formData,iconPath_5:""})
                            }
                          >
                            <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                          </span>
                        </label>
                      )}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="btn"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {isAddService?.rowData === null ? "Save" : "Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
